export enum CompileResultType {
    SUCCESS = 0,
    FAILED = 1,
    PROCESSING = 2
}